const langs = [
  { value: 'en', label: 'English' },
  { value: 'da', label: 'Danish' },
];

export default langs;
